import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { environment } from 'src/environments/environment';
import { httpInterceptor } from './shared/services/http-inter/http-inter.interceptor';
import { LazyBugsnagErrorHandler } from './shared/error-handler/error-handler.module';

export const ERROR_HANDLER_PROVIDER = environment.production ? [{ provide: ErrorHandler, useClass: LazyBugsnagErrorHandler }] : [];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch(), withInterceptors([httpInterceptor])),
    provideRouter(routes),
    provideClientHydration(),
    ...ERROR_HANDLER_PROVIDER
  ]
};
